import React, {useEffect, useState, useRef} from 'react';
import AdminHeader from '../Section/AdminHeader';
import { ReactTabulator } from 'react-tabulator';
import * as H from '../../Styles/StyleComponentHan';
import {
  get_mourning_clothes,
  update_mourning_clothes_order,
} from "../../Axios";

export function AdminMourningClothesManagement() {  

  const [mourningClothesData, setMourningClothesData] = useState([]); 

  const tabulatorRef = useRef();

  const row_moved_function = (e, row) => {  

    let temp_mourning_clothes_order_array = [];
    let mourning_clothes_order= 0;

    tabulatorRef.current.optionsList.table.rowManager.activeRows.forEach(element =>{
      temp_mourning_clothes_order_array.push({
        mourning_clothes_order: mourning_clothes_order,
        mourning_clothes_ID: element.data.mourning_clothes_ID,
      })
      mourning_clothes_order++;
    });
    update_mourning_clothes_order(temp_mourning_clothes_order_array).then(result=>{
      if(result === undefined){
        alert('순서가 변경되지 않았습니다. 관리자한테 확인해주세요.');
      }
    })    
  };

  const check_mourning_clothes_edit = () =>{
    if(tabulatorRef.current.getSelectedData().length > 1){
      alert('수정할 데이터를 하나만 선택해주세요.');
    } else if(tabulatorRef.current.getSelectedData().length === 0){
      alert('수정할 데이터를 선택해주세요.');
    } else{
      window.location.href = `/AdminMourningClothesManagementAdd?mourning_clothes_ID=${tabulatorRef.current.getSelectedData()[0].mourning_clothes_ID}`;
    }
  }

  useEffect(() => {
    get_mourning_clothes().then(result_data=>{
      setMourningClothesData(result_data);
    })
  },[]);

  return (
    <H.admin_MainWrap>
      <AdminHeader/>
      <H.admin_rightWrap>
        <H.admin_rightTitBox>
          <H.admin_rightTitInner>
            <p>견적 메뉴 관리 - 상복대여 관리</p>
            <div>
              <H.admin_addBtn
                onClick={()=>{window.location.href = "/AdminMourningClothesManagementAdd";}}>등록
              </H.admin_addBtn>
              <H.admin_changeBtn
                onClick={()=>{check_mourning_clothes_edit();}}>수정
              </H.admin_changeBtn>
            </div>
            </H.admin_rightTitInner>
          </H.admin_rightTitBox>
          
        <H.admin_rightInfoBox>
          <H.admin_rightInfoInner>
            <H.listInfoText>
              <p className="listInfoTextBold">사용 방법 안내</p>
              <p>1. 리스트 중 상단이 정렬 우선순위가 높습니다.</p>
              <p>2. 왼쪽 3선 작대기를 클릭 ➡️ 드래그하여 위/아래로 이동할 수 있습니다.</p>
              <p>3. 삭제는 안되며 수정만 가능합니다.</p>
            </H.listInfoText>
            {
            mourningClothesData.length !== 0 ? 
            <ReactTabulator
              onRef={(r) => (tabulatorRef.current = r.current)}
              data={mourningClothesData}
              columns={[
                {rowHandle:true, formatter:"handle", headerSort:false, frozen:true, width:30, minWidth:30},
                {formatter:"rowSelection", titleFormatter:"rowSelection", headerSort:false, 
                  cellClick:function(e, cell){
                    cell.getRow().toggleSelect();
                  }
                },
                { title: "ID", field: "mourning_clothes_ID", headerSort:false},
                { title: "상복대여 명칭", field: "mourning_clothes_name", headerSort:false},
                { title: "가격", field: "mourning_clothes_price", headerSort:false, formatter:"money", 
                  formatterParams:
                  {
                    decimal:",",
                    thousand:",",
                    symbol:"원",
                    symbolAfter:"p",
                    negativeSign:true,
                    precision:false
                  },
                },
                { title: "사용 여부", field: "mourning_clothes_status", headerSort:false},
                { title: "등록 일자", field: "mourning_clothes_registe", headerSort:false},
                { title: "수정 일자", field: "mourning_clothes_modified", headerSort:false},
              ]}
              layout={"fitData"}
              options={{
                movableRows: true,
              }}
              events={{
                rowMoved:row_moved_function
              }}
              />
            : 
            <div>
              <p>데이터가 없습니다.</p>  
            </div>
            }
          </H.admin_rightInfoInner>
        </H.admin_rightInfoBox>

      </H.admin_rightWrap>
    </H.admin_MainWrap>
  );
}

export default AdminMourningClothesManagement;
